export const ErrorMessages = {
    noSchoolSlug: 'Please use your school-specific login URL.',
    default: 'Sorry, an unexpected error has occurred.',
};
